__webpack_require__.p = "/forecast-widget/";